import { MessageBox } from "element-ui";
import { clear } from "../utils/storage";

const NO_ERROR_MSG_CODE = [403];
const errorMsgStack = new Map([]);

const addErrorMsg = (error) => {
    errorMsgStack.set(error, error);
};
const removeErrorMsg = (error) => {
    errorMsgStack.delete(error);
};
const hasErrorMsg = (error) => {
    return errorMsgStack.has(error);
};

/**
 * 显示错误信息 403 退出登陆
 * @param error
 */
export const handleAuthError = (error) => {
    if (!error) return;
    if (NO_ERROR_MSG_CODE.includes(error)) {
        const msgDiv = document.getElementsByClassName("message-custom-403");
        if (msgDiv.length <= 0 && !hasErrorMsg(error)) {
            addErrorMsg(error);
            MessageBox.confirm(
                `无效的会话，或者会话已过期，请重新登录。`,
                "系统提示",
                {
                    confirmButtonText: "重新登录",
                    showClose: false,
                    showCancelButton: false,
                    type: "warning",
                    customClass: "message-custom-403",
                }
            )
                .then(() => {
                    clear("token", true);
                    location.href = window.location.origin + "/login";
                })
                .catch(() => {
                    console.log("confirm err");
                });
            setTimeout(() => {
                removeErrorMsg(error);
            }, 1000);
        }
    }
};
